/**
 * Records the last N mousemove deltas and computes simple entropy metrics:
 * - angle stddev (rad) — straight-line bot movement has near-zero angle variance
 * - speed stddev (px/ms) — bots often move at constant speed
 */
const MAX_SAMPLES = 60;
const angles: number[] = [];
const speeds: number[] = [];
let last: { x: number; y: number; t: number } | null = null;

if (typeof window !== 'undefined') {
  window.addEventListener(
    'mousemove',
    (e) => {
      const now = performance.now();
      if (last) {
        const dx = e.clientX - last.x;
        const dy = e.clientY - last.y;
        const dt = now - last.t;
        if (dt > 0 && (dx !== 0 || dy !== 0)) {
          angles.push(Math.atan2(dy, dx));
          speeds.push(Math.hypot(dx, dy) / dt);
          if (angles.length > MAX_SAMPLES) angles.shift();
          if (speeds.length > MAX_SAMPLES) speeds.shift();
        }
      }
      last = { x: e.clientX, y: e.clientY, t: now };
    },
    { passive: true },
  );
}

function stddev(arr: number[]): number {
  const n = arr.length;
  if (n < 2) return 0;
  const mean = arr.reduce((a, b) => a + b, 0) / n;
  const v = arr.reduce((a, b) => a + (b - mean) ** 2, 0) / n;
  return Math.sqrt(v);
}

export function getMouseStats(): {
  count: number;
  angleStdDev?: number;
  speedStdDev?: number;
} {
  if (angles.length < 5) return { count: angles.length };
  return {
    count: angles.length,
    angleStdDev: Number(stddev(angles).toFixed(4)),
    speedStdDev: Number(stddev(speeds).toFixed(4)),
  };
}
